import React from "react";
import Settings from '../../services/settings.service';
import GTMService from "../../services/gtm.service";

const GetApp = props => {
	return (
		<div className="download-app">
			<div className="download-app-title">Why not to download the app?</div>
			<a href={Settings.app_store_link} target="_blank" rel="noopener noreferrer" className="app"
			onClick={() => {
				GTMService.action_on_get_the_app_link();
			}}>
				<i className="appstore" /> App Store
			</a>
			<span />
			<a href={Settings.google_play_link} target="_blank" rel="noopener noreferrer" className="app"
			onClick={() => {
				GTMService.action_on_get_the_app_link();
			}}>
				<i className="playstore" /> Google Play
			</a>
		</div>
	);
};

export default GetApp;